import { useEffect, useState } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { apiFetch, ApiError } from '../lib/api';

export function Dashboard() {
  const { user } = useAuth();
  const [rows, setRows] = useState<unknown[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    apiFetch<unknown[]>('/api/reports/example')
      .then((data) => {
        if (active) setRows(Array.isArray(data) ? data : []);
      })
      .catch((err: unknown) => {
        if (!active) return;
        setError(err instanceof ApiError ? err.message : 'Failed to load report');
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <section className="page">
      <h1>Dashboard</h1>
      <p>
        Welcome back, <strong>{user?.email}</strong>. Data below comes from the
        Worker&rsquo;s <code>/api/reports/example</code> endpoint, which queries
        Supabase using the server-side secret key.
      </p>
      {error && <p className="form-error" role="alert">{error}</p>}
      {!error && rows === null && <p className="muted">Loading…</p>}
      {!error && rows && rows.length === 0 && (
        <p className="muted">No rows returned. Wire up your own report query in <code>worker/index.ts</code>.</p>
      )}
      {!error && rows && rows.length > 0 && (
        <pre className="code-block">{JSON.stringify(rows, null, 2)}</pre>
      )}
    </section>
  );
}
